import { KARLA_FONT_FAMILY } from '../../../../libs/end-to-end/src/types/branding/fonts';

export const primary = {
  background: 'transparent',
  text: {
    color: '#000000',
    fontFamily: KARLA_FONT_FAMILY,
    fontSize: 16,
  },
  axis: {
    domain: {
      line: {
        stroke: '#777777',
        strokeWidth: 1,
      },
    },
    ticks: {
      line: {
        stroke: '#777777',
        strokeWidth: 1,
      },
      text: {
        fontWeight: 'bold',
        fontSize: 14,
      },
    },
  },
  grid: {
    line: {
      stroke: '#dddddd',
      strokeWidth: 1,
    },
  },
};

export const predictionsChart = {
  background: 'transparent',
  text: {
    color: '#ffffff',
    fontFamily: KARLA_FONT_FAMILY,
    fontSize: 16,
  },
  axis: {
    domain: {
      line: {
        stroke: '#ffffff',
        strokeWidth: 0.5,
      },
    },
    ticks: {
      line: {
        stroke: '#fffff',
        strokeWidth: 1,
      },
    },
  },
  grid: {
    line: {
      stroke: '#9DA0A3',
      strokeWidth: 0.5,
    },
  },
};
